package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Embedded
import androidx.room3.Query
import androidx.room3.RawQuery
import androidx.room3.Relation
import androidx.room3.RoomRawQuery
import androidx.room3.Transaction
import com.xtream.data_kmp.AllConst.ALL_CATEGORIES_ID
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.LiveStreamWithSortOrder
import kotlinx.coroutines.flow.Flow

enum class LiveSortBy {
    DEFAULT,
    NAME_ASC,
    NAME_DESC,
    LAST_ADDED,
    CATEGORY
}
@Dao
abstract class LiveStreamsDao:BaseRoomStreamsInterface<LiveStream> {

    // ── NOT migrated ──────────────────────────────────────────────────────────

    @Query("SELECT * FROM liveStreamsTable WHERE streamId = :id LIMIT 1")
    abstract suspend fun getStreamById(id: Int?): LiveStream?

    // ── MIGRATED ──────────────────────────────────────────────────────────────

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY added DESC LIMIT 10
    """)
    abstract override suspend fun recentlyAdded(): List<LiveStream>

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY added DESC LIMIT :limit
    """)
    abstract override fun recentlyAddedFlow(limit: Int): Flow<List<LiveStream>>

    @Query("""
        SELECT COUNT(*) FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY added DESC LIMIT 10
    """)
    abstract override fun getRecentlyAddedSize(): Flow<Long>

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY num ASC
    """)
    abstract override fun allAsFlow(): Flow<List<LiveStream>>

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR liveStreamsTable.name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
                + " LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/
    )
    abstract suspend fun all(
        categoryId: Int?,
        nameQuery: String?,
        limit: Int?,
        offset: Int?
    ): List<LiveStream>

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR liveStreamsTable.name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
                + " LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/
    )
    abstract override fun allAsFlow(
        categoryId: Int?,
        nameQuery: String?,
        limit: Int?,
        offset: Int?
    ): Flow<List<LiveStream>>

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR liveStreamsTable.name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        /*+"ORDER BY sortOrder"*/
    )
    abstract override fun allAsFlow(categoryId: Int?, nameQuery: String?): Flow<List<LiveStream>>

    @Query("""
    SELECT liveStreamsTable.* FROM liveStreamsTable
    LEFT JOIN live_stream_order o ON liveStreamsTable.streamId = o.streamId
    LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
    WHERE h.categoryId IS NULL
    AND (:categoryId = $ALL_CATEGORIES_ID OR liveStreamsTable.categoryId = :categoryId)
    ORDER BY
        COALESCE(o.position, liveStreamsTable.num),
        CASE WHEN o.position IS NOT NULL THEN 0 ELSE 1 END
    LIMIT 1 OFFSET :offset
""")
    abstract suspend fun getByOffset(categoryId: Int?, offset: Int): LiveStream?

    // ── NOT migrated ──────────────────────────────────────────────────────────

    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC" +
                " LIMIT :limit"
    )
    abstract override fun getFavoriteStreamsFlow(limit: Int?): Flow<List<LiveStream>>

    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC"
    )
    abstract override suspend fun getFavoriteStreams(): List<LiveStream>

    // ── MIGRATED ──────────────────────────────────────────────────────────────

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR liveStreamsTable.name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        /*+"ORDER BY sortOrder"*/
    )
    abstract override fun allAsPagingSource(
        categoryId: Int?,
        nameQuery: String?
    ): PagingSource<Int, LiveStream>

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND liveStreamsTable.categoryId IN (:categoryIds)"
                + " AND (:nameQuery IS NULL OR liveStreamsTable.name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        /*+"ORDER BY sortOrder"*/
    )
    abstract override fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?
    ): PagingSource<Int, LiveStream>

    @RawQuery(observedEntities = [LiveStream::class])
    abstract fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, LiveStream>

    fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: LiveSortBy,
    ): PagingSource<Int, LiveStream> {
        val orderClause = when (sortBy) {
            LiveSortBy.DEFAULT    -> "num ASC"
            LiveSortBy.NAME_ASC   -> "name ASC"
            LiveSortBy.NAME_DESC  -> "name DESC"
            LiveSortBy.LAST_ADDED -> "added DESC"
            LiveSortBy.CATEGORY   -> "categoryId ASC, num ASC"
        }

        val args = mutableListOf<Any>()
        val whereClause = buildString {
            append("WHERE h.categoryId IS NULL ")
            if (!categoryIds.isNullOrEmpty()) {
                val placeholders = categoryIds.joinToString(",") { "?" }
                append("AND categoryId IN ($placeholders) ")
                args.addAll(categoryIds)
            }
            if (!nameQuery.isNullOrEmpty()) {
                append("AND name LIKE ? ")
                args.add("%$nameQuery%")
            }
        }

        val sql = """
            SELECT liveStreamsTable.* FROM liveStreamsTable
            LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
            $whereClause ORDER BY $orderClause
        """.trimIndent()

        return allAsPagingSourceRaw(RoomRawQuery(sql) { stmt ->
            args.forEachIndexed { index, arg ->
                when (arg) {
                    is Int    -> stmt.bindLong(index + 1, arg.toLong())
                    is String -> stmt.bindText(index + 1, arg)
                }
            }
        })
    }

    @Transaction
    @Query("""
        SELECT liveCategoriesTable.* FROM liveCategoriesTable
        LEFT JOIN hidden_categories h
            ON liveCategoriesTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY 
            liveCategoriesTable.created_at
    """)
    abstract fun categoriesWithStreams(): PagingSource<Int, LiveCategoryWithStreams>



    data class LiveCategoryWithStreams(
        @Embedded
        val category: LiveCategory,
        @Relation(
            parentColumns = ["categoryId"],
            entityColumns = ["categoryId"]
        )
        val stream: List<LiveStream>
    )

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY num ASC
        LIMIT :limit
    """)
    abstract override fun getRecentlyAdded(limit: Int): PagingSource<Int, LiveStream>

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY added DESC
        LIMIT :limit
    """)
    abstract override fun getRecentlyAddedFlow(limit: Int): Flow<List<LiveStream>>

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        ORDER BY added DESC
        LIMIT :limit
    """)
    abstract suspend fun getRecentlyAddedList(limit: Int): List<LiveStream>

    @Query("""
        SELECT liveStreamsTable.* FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)
        ORDER BY added DESC
        LIMIT :limit
    """)
    abstract override fun getRecommendations(
        categoryId: Int?,
        limit: Int
    ): PagingSource<Int, LiveStream>

    @Query(
        "SELECT liveStreamsTable.* FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "ORDER BY num ASC"
        /*+"ORDER BY sortOrder"*/
    )
    abstract override fun allAsPagingSource(): PagingSource<Int, LiveStream>

    // ── NOT migrated ──────────────────────────────────────────────────────────

    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC"
    )
    abstract override fun getPagedFavoriteStreams(): PagingSource<Int, LiveStream>

    @Query(
        "SELECT liveStreamsTable.*  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC "
    )
    abstract override fun getPagedWatchedStreams(): PagingSource<Int, LiveStream>

    @Query(
        "SELECT liveStreamsTable.*  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC LIMIT :limit"
    )
    abstract suspend fun getWatchedStreams(limit: Int?): List<LiveStream>

    @Query(
        "SELECT liveStreamsTable.*  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC LIMIT :limit"
    )
    abstract override fun getWatchedStreamsFlow(limit: Int?): Flow<List<LiveStream>>

    @Query("SELECT EXISTS (SELECT 1 FROM liveStreamsTable WHERE streamId = :id)")
    abstract override suspend fun hasEntity(id: Int): Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM liveStreamsTable WHERE streamId = :id)")
    abstract override fun hasEntityAsFlow(id: Int?): Flow<Boolean>

    // ── MIGRATED ──────────────────────────────────────────────────────────────

    @Query("""
        SELECT COUNT(*) FROM liveStreamsTable
        LEFT JOIN hidden_categories h
            ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
    """)
    abstract override suspend fun getSize(): Long?

    @Query(
        "SELECT COUNT(*) FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR :categoryId = $ALL_CATEGORIES_ID OR liveStreamsTable.categoryId = :categoryId)"
    )
    abstract override suspend fun getSize(categoryId: Int?): Long?

    @Query(
        "SELECT COUNT(*) FROM liveStreamsTable "
                + "LEFT JOIN hidden_categories h ON liveStreamsTable.categoryId = h.categoryId AND h.type = 'LIVE' "
                + "WHERE h.categoryId IS NULL "
                + "AND (:categoryId IS NULL OR liveStreamsTable.categoryId = :categoryId)"
    )
    abstract override fun getSizeAsFlow(categoryId: Int?): Flow<Long?>

    // ── NOT migrated ──────────────────────────────────────────────────────────

    @Query("DELETE FROM liveStreamsTable")
    abstract override suspend fun deleteAll()

    @RawQuery
    abstract suspend fun indexOf(rawQuery: RoomRawQuery): Int?

    // ── MIGRATED ──────────────────────────────────────────────────────────────

    @Transaction
    @Query("""
        SELECT l.*
        FROM liveStreamsTable l
        LEFT JOIN live_stream_order o
            ON l.streamId = o.streamId
        LEFT JOIN hidden_categories h
            ON l.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        AND (:categoryId IS NULL OR l.categoryId = :categoryId)
        ORDER BY
            COALESCE(o.position, l.num),
            CASE WHEN o.position IS NOT NULL THEN 0 ELSE 1 END
    """)
    abstract fun getOrdered(categoryId: Int?): Flow<List<LiveStreamWithSortOrder>>

    @Transaction
    @Query("""
        SELECT l.*
        FROM liveStreamsTable l
        LEFT JOIN live_stream_order o
            ON l.streamId = o.streamId
        LEFT JOIN hidden_categories h
            ON l.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        AND (:categoryId IS NULL OR l.categoryId = :categoryId)
        ORDER BY
            COALESCE(o.position, l.num),
            CASE WHEN o.position IS NOT NULL THEN 0 ELSE 1 END
    """)
    abstract suspend fun getOrderedTvChannelsList(categoryId: Int?): List<LiveStreamWithSortOrder>
}
/*
@Dao
abstract class LiveStreamsDao:BaseRoomStreamsInterface<LiveStream> {

    @Query("SELECT * FROM liveStreamsTable WHERE streamId = :id LIMIT 1")
    abstract suspend fun getStreamById(id: Int?): LiveStream?


    @Query("SELECT * FROM liveStreamsTable ORDER BY added DESC LIMIT 10")
    abstract override suspend fun recentlyAdded(): List<LiveStream>

    @Query("SELECT * FROM liveStreamsTable ORDER BY added DESC LIMIT :limit")
    abstract override fun recentlyAddedFlow(limit: Int): Flow<List<LiveStream>>

    @Query("SELECT COUNT(*) FROM liveStreamsTable ORDER BY added DESC LIMIT 10")
    abstract override fun getRecentlyAddedSize(): Flow<Long>

    @Query("SELECT * FROM liveStreamsTable ORDER BY num ASC")
    abstract override fun allAsFlow(): Flow<List<LiveStream>>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + "WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
                + " LIMIT :limit OFFSET :offset"

        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract suspend fun all(
        categoryId: Int?,
        nameQuery: String?,
        limit: Int?,
        offset: Int?
    ): List<LiveStream>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + "WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
                + " LIMIT :limit OFFSET :offset"

        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract override fun allAsFlow(
        categoryId: Int?,
        nameQuery: String?,
        limit: Int?,
        offset: Int?
    ): Flow<List<LiveStream>>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + "WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract override fun allAsFlow(categoryId: Int?, nameQuery: String?): Flow<List<LiveStream>>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + " WHERE (:categoryId = $ALL_CATEGORIES_ID OR categoryId = :categoryId) "
                + "ORDER BY num ASC"
                + " LIMIT 1 OFFSET :offset"
        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract suspend fun getByOffset(categoryId: Int?, offset: Int): LiveStream?

    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC" +
                " LIMIT :limit"
    )
    abstract override fun getFavoriteStreamsFlow(limit: Int?): Flow<List<LiveStream>>

    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC"
    )
    abstract override suspend fun getFavoriteStreams(): List<LiveStream>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + "WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
                + " AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract override fun allAsPagingSource(
        categoryId: Int?,
        nameQuery: String?
    ): PagingSource<Int, LiveStream>

    @Query(
        "SELECT * FROM liveStreamsTable "
                + "WHERE categoryId IN (:categoryIds)"
                + " AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
                + "ORDER BY num ASC"
        */
/*+"ORDER BY sortOrder"*//*

    ) abstract override fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?
    ): PagingSource<Int, LiveStream>

    @RawQuery(observedEntities = [LiveStream::class])
    abstract fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, LiveStream>
    fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: LiveSortBy,
    ): PagingSource<Int, LiveStream> {
        val orderClause = when (sortBy) {
            LiveSortBy.DEFAULT    -> "num ASC"
            LiveSortBy.NAME_ASC   -> "name ASC"
            LiveSortBy.NAME_DESC  -> "name DESC"
            LiveSortBy.LAST_ADDED -> "added DESC"
            LiveSortBy.CATEGORY   -> "categoryId ASC, num ASC"
        }

        val args = mutableListOf<Any>()
        val whereClause = buildString {
            append("WHERE 1=1 ")
            if (!categoryIds.isNullOrEmpty()) {
                val placeholders = categoryIds.joinToString(",") { "?" }
                append("AND categoryId IN ($placeholders) ")
                args.addAll(categoryIds)
            }
            if (!nameQuery.isNullOrEmpty()) {
                append("AND name LIKE ? ")
                args.add("%$nameQuery%")
            }
        }

        val sql = "SELECT * FROM liveStreamsTable $whereClause ORDER BY $orderClause"

        return allAsPagingSourceRaw(RoomRawQuery(sql) { stmt ->
            args.forEachIndexed { index, arg ->
                when (arg) {
                    is Int    -> stmt.bindLong(index + 1, arg.toLong())
                    is String -> stmt.bindText(index + 1, arg)
                }
            }
        })
    }
    @Transaction
    @Query(
        """
SELECT  * FROM liveCategoriesTable

ORDER BY 
    liveCategoriesTable.created_at
    
    """
    )
    abstract fun categoriesWithStreams(): PagingSource<Int, LiveCategoryWithStreams>

    @Transaction
    @Query(
        """
    SELECT * FROM liveCategoriesTable 
        JOIN liveStreamsTable ON livecategoriestable.categoryId = livestreamstable.categoryId
    ORDER BY 
        liveCategoriesTable.created_at,
        liveStreamsTable.num
    """
    )
    abstract suspend fun categoriesWithStreamsFlow(): Map<LiveCategory, List<LiveStream>>

    @Transaction
    @Query(
        """
    SELECT * FROM liveCategoriesTable 
        JOIN liveStreamsTable ON livecategoriestable.categoryId = livestreamstable.categoryId
    ORDER BY 
        liveCategoriesTable.created_at,
        liveStreamsTable.num
    """
    )
    abstract fun categoriesWithStreamsFlowTest(): Flow<Map<LiveCategory, List<LiveStream>>>
   // 
    data class LiveCategoryWithStreams(
        @Embedded
        val category: LiveCategory,
        @Relation(
            parentColumns = ["categoryId"],
            entityColumns = ["categoryId"]
        )
        val stream: List<LiveStream>
    )

    @Query(
        """
        SELECT * FROM liveStreamsTable
        ORDER BY num ASC
        LIMIT :limit
    """
    )
    abstract override fun getRecentlyAdded(limit: Int): PagingSource<Int, LiveStream>


    @Query(
        """
        SELECT * FROM liveStreamsTable
         ORDER BY added DESC
        LIMIT :limit
    """
    )
    abstract override fun getRecentlyAddedFlow(limit: Int): Flow<List<LiveStream>>


    @Query(
        """
        SELECT * FROM liveStreamsTable
         ORDER BY added DESC
        LIMIT :limit
    """
    )
    abstract suspend fun getRecentlyAddedList(limit: Int): List<LiveStream>


    @Query(
        """
        SELECT * FROM liveStreamsTable
        WHERE (:categoryId IS NULL OR categoryId = :categoryId)
        ORDER BY added DESC
        LIMIT :limit
    """
    )
    abstract override fun getRecommendations(
        categoryId: Int?,
        limit: Int
    ): PagingSource<Int, LiveStream>


    @Query(
        "SELECT * FROM liveStreamsTable "

                + "ORDER BY num ASC"
        */
/*+"ORDER BY sortOrder"*//*

    )
    abstract override fun allAsPagingSource(): PagingSource<Int, LiveStream>


    @Query(
        "SELECT liveStreamsTable.*, liveFavoritesTable.sortOrder AS  'num' " +
                "FROM liveStreamsTable" +
                " INNER JOIN liveFavoritesTable ON liveStreamsTable.streamId = liveFavoritesTable.streamId " +
                "ORDER BY liveFavoritesTable.sortOrder ASC"
    )
    abstract override fun getPagedFavoriteStreams(): PagingSource<Int, LiveStream>

    @Query(
        "SELECT *  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC "
    )
    abstract override fun getPagedWatchedStreams(): PagingSource<Int, LiveStream>

    @Query(
        "SELECT *  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC LIMIT :limit"
    )
    abstract suspend fun getWatchedStreams(limit: Int?): List<LiveStream>


    @Query(
        "SELECT *  FROM liveStreamsTable " +
                "INNER JOIN watchedLiveStreamsTable ON liveStreamsTable.streamId = watchedLiveStreamsTable.streamId " +
                " ORDER BY watchedLiveStreamsTable.added DESC LIMIT :limit"

    )
    abstract override fun getWatchedStreamsFlow(limit: Int?): Flow<List<LiveStream>>

    @Query("SELECT EXISTS (SELECT 1 FROM liveStreamsTable WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id: Int): Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM liveStreamsTable WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id: Int?): Flow<Boolean>

    @Query("SELECT COUNT(*) FROM liveStreamsTable ")
    abstract override suspend fun getSize(): Long?

    @Query(
        "SELECT COUNT(*) FROM liveStreamsTable "
                + " WHERE (:categoryId IS NULL OR :categoryId = $ALL_CATEGORIES_ID OR categoryId = :categoryId)"
    )
    abstract override suspend fun getSize(categoryId: Int?): Long?

    @Query(
        "SELECT COUNT(*) FROM liveStreamsTable"
                + " WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
    )
    abstract override fun getSizeAsFlow(categoryId: Int?): Flow<Long?>

    @Query("DELETE FROM liveStreamsTable")
    abstract override suspend fun deleteAll()

    @RawQuery
    abstract suspend fun indexOf(rawQuery: RoomRawQuery): Int?


    @Transaction
    @Query("""
    SELECT *
    FROM liveStreamsTable l
    LEFT JOIN live_stream_order o
        ON l.streamId = o.streamId
    WHERE (:categoryId IS NULL OR l.categoryId = :categoryId)
    ORDER BY
        COALESCE(o.position, l.num),
        CASE WHEN o.position IS NOT NULL THEN 0 ELSE 1 END
""")
    abstract fun getOrdered(categoryId: Int?): Flow<List<LiveStreamWithSortOrder>>
}

*/
